import React, { Component } from 'react';
import DatePicker from '../common/datepicker';
import { TableHeaderColumn } from 'react-bootstrap-table';
import UserSearch from '../common/userSearch';
import DataGrid from '../common/dataGrid';
import dateHelper from '../../helpers/date.js';
import { CheckBox, ApplyAndReset } from '../common/forms';
import enums from '../../config/enums';
import CSVExport from '../common/CSVExport';


module.exports = class Plans extends React.Component {
    constructor(props) {
        super(props);

        this.showHistory = this.showHistory.bind(this);
        this.state = {
            isHistory: false,
            doctorID: 0,
            connectedUserID: this.props.connectedUserID
        }

        this.ExpandFormater = this.ExpandFormater.bind(this);
    }

    isExpandable(row) {
        //if (row.Details == null)    return false;
        return true;
    }

    updateDoctor(id) {
        this.setState({ doctorID: id });
    }

    expandComponent(row) {
        return (
            <table className='exapandbleRowTable'>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{row.LLLT != null ? row.LLLT.allData : ''}</td>
                        <td>{row.EMT != null ? row.EMT.allData : ''}</td>
                        <td>{row.RF != null ? row.RF.allData : ''}</td>
                        <td>{row.Measurement != null ? row.Measurement.allData : ''}</td>
                        <td width='19'></td>
                    </tr>
                </tbody>
            </table>
        );
    }

    rowClick(row) {
        if (row.isExpanded == undefined || row.isExpanded == false)
            row.isExpanded = true;
        else
            row.isExpanded = false;
    }

    trClassFormat(row, rowIndex) {
        if (row.isExpanded)
            return 'tr-expanded';

        // row is the current row data
        return rowIndex % 2 === 0
            ? "tr-odd"
            : "tr-even"; // return class name.
    }

    showHistory() {
        var isHistory = this.state.isHistory;
        this.setState({ isHistory: !isHistory });
        var params = {
            userID: this.props.patientID,
            includeHistory: !isHistory
        };
        this._grid.setNewParameters(params)
        this._historyBtn.blur();
    }

    ExpandFormater(cell, row) {
        if (row.isExpanded != undefined && row.isExpanded == true)
            return (
                <div className='MoreInfo' onClick={() => this.rowClick(row)}>-</div>
            );
        else
            return (
                <div className='MoreInfo' onClick={() => this.rowClick(row)}>+</div>
            );
    }

    render() {
        var params = {
            userID: this.props.patientID,
            includeHistory: this.state.isHistory
        };
        var doctorAdviceLink = "/doctorAdvice/" + this.props.patientID;
        var buttonStyle = {
            width: '100px',
            height: '35px',
            display: 'inline-block',
            marginRight: '20px',
            outline: "none"
        };

        var historyBtnClass = "hoverpurple  btn btn-default btn btn-default";
        if (this.state.isHistory) {
            historyBtnClass = 'purple btn btn-default btn btn-default';
        }

        var planClass = 'purple btn btn-default btn btn-default';
        if (this.state.connectedUserID != this.state.doctorID) {
            planClass = "hidden";
        }

        return (
            <div>
                <div className='row'>
                    <div className='col-md-8'>
                        <h3>Current Plan</h3>
                    </div>
                    <div className='float-right'>
                                <CSVExport 
                                ajaxUrl='/data/getUsersActivePlans' 
                                parameters={params} 
                                dbKeys={['ID', 'PlanType', 'Created', 'Ended', 'LLLT', 'EMT', 'RF', 'Measurement']} 
                                csvKeys={['ID', 'Plan Type', 'Start Date', 'End Date', 'LLLT', 'EMT', 'RF', 'Measurement']}
                                dataFormatters={[null, null, null, null, LLLTFormaterCSV, RFFormaterCSV, RFFormaterCSV, MeasurementFormaterCSV]}
                                fileName={'Patient_Plans_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>
                    </div>
                    <div className='float-right'>
                        <a href={doctorAdviceLink}><button className={planClass} style={buttonStyle}>UPDATE PLAN</button></a>
                        <button className={historyBtnClass} style={buttonStyle} onClick={this.showHistory} 
                        ref={(historyBtn) => {
                            this._historyBtn = historyBtn;
                        }}>HISTORY</button>
                    </div>
                </div>
                <DataGrid
                    ajaxUrl='/data/getUsersActivePlans'
                    ID='UserPlans'
                    parameters={params}
                    OnClick={this.rowClick}
                    ExpandableRow={this.isExpandable}
                    trClassFormat={this.trClassFormat}
                    ExpandComponent={this.expandComponent} ref={(grid) => { this._grid = grid; }}
                    pagination={true}>
                    <TableHeaderColumn dataField='ID' isKey={true} hidden>Patient Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='PlanType' dataSort>Plan Type</TableHeaderColumn>
                    <TableHeaderColumn dataField='Created' dataFormat={dateFormatter} dataSort>Start Date</TableHeaderColumn>
                    <TableHeaderColumn dataField='Ended' dataFormat={dateFormatter} dataSort>End Date</TableHeaderColumn>
                    <TableHeaderColumn dataField='LLLT' dataFormat={LLLTFormater} dataSort>LLLT</TableHeaderColumn>
                    <TableHeaderColumn dataField='EMT' dataFormat={EMTFormater} dataSort>ELP</TableHeaderColumn>
                    <TableHeaderColumn dataField='RF' dataFormat={RFFormater} dataSort>RF</TableHeaderColumn>
                    <TableHeaderColumn dataField='Measurement' dataFormat={MeasurementFormater} dataSort>Measurement</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={this.ExpandFormater} dataField='' width='35'></TableHeaderColumn>
                </DataGrid>
            </div>
        )
    }
}

var MoreDetailsContainer = React.createClass({
    MoreDetailsRow: function (key, data) {
        return <div key={key}>{data}</div>;
    },
    createContainer: function (data) {
        var columnData = [];
        for (var prop in data) {
            var rowData = prop + " = " + data[prop];
            columnData.push(this.MoreDetailsRow(prop, rowData));
        }
        return columnData;
    },
    render: function () {
        return (
            <div>{this.createContainer(this.props.data)}</div>
        )
    }
});

function LLLTFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {
        cell.firstRow = "Wave = " + cell.Wave;

        var allData = [];
        if (cell.PowerLevel658)
            allData.push(<div key="658">Power 658 = {cell.PowerLevel658}</div>);
        if (cell.PowerLevel852)
            allData.push(<div key="852">Power 852 = {cell.PowerLevel852}</div>);
        allData.push(<div key="duration">Duration = {cell.Duration}</div>);

        allData = allData.concat(parseRepeatData(cell.Repeat));

        cell.allData = allData;

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}

function LLLTFormaterCSV(cell) {
    if (cell == null) {
        return "";
    }

    var allData = [];
    allData.push("Wave = " + cell.Wave);
    if (cell.PowerLevel658)
        allData.push("Power 658 =" + cell.PowerLevel658);
    if (cell.PowerLevel852)
        allData.push("Power 852 = " + cell.PowerLevel852);
    allData.push("Duration = " + cell.Duration);
    allData = allData.concat(parseRepeatDataCSV(cell.Repeat));
    return allData.join(" - ");
}

function RFFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {
        cell.firstRow = "Power = " + cell.PowerLevel;

        var allData = [];
        allData.push(<div key="Duration">Duration = {cell.Duration}</div>);

        allData = allData.concat(parseRepeatData(cell.Repeat));

        cell.allData = allData;

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}


function RFFormaterCSV(cell) {
    if (cell == null) {
        return "";
    }

    var allData = [];
    allData.push("Power =" + cell.PowerLevel);
    allData.push("Duration = " + cell.Duration);
    allData = allData.concat(parseRepeatDataCSV(cell.Repeat));
    return allData.join(" - ");
}

function EMTFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {
        cell.firstRow = "Power = " + cell.PowerLevel;

        var allData = [];
        allData.push(<div key="Duration">Duration = {cell.Duration}</div>);

        allData = allData.concat(parseRepeatData(cell.Repeat));

        cell.allData = allData;

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}

function MeasurementFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {

        cell.firstRow = "Repeat type = " + cell.Repeat.RepeatType;

        var repeatData = parseRepeatData(cell.Repeat);
        if (repeatData.length > 1) {
            repeatData = repeatData.splice(1,1);
            cell.allData = repeatData;
        }

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}

function MeasurementFormaterCSV(cell) {
    if (cell == null) {
        return "";
    }

    var allData = [];
    allData = allData.concat(parseRepeatDataCSV(cell.Repeat));
    return allData.join(" - ");
}




var weekday = new Array(8);
weekday[1] = "Sunday";
weekday[2] = "Monday";
weekday[3] = "Tuesday";
weekday[4] = "Wednesday";
weekday[5] = "Thursday";
weekday[6] = "Friday";
weekday[7] = "Saturday";

function parseRepeatData(repeat) {
    var repeatData = [];
    if (repeat != null) {
        repeatData.push(<div key="type">Repeat type = {repeat.RepeatType}</div>);
        if (repeat.RepeatTypeID == enums.PLAN_REPEAT.WEEKLY)// || repeat.repeatTypeID == enums.PLAN_REPEAT.BIWEEKLY)
        {
            repeatData.push(<div key="day">Repeat day = {weekday[repeat.RepeatDay[0]]}</div>);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.BIWEEKLY) {
            repeatData.push(<div key="days">Repeat days = {weekday[repeat.RepeatDay[0]]}, {weekday[repeat.RepeatDay[1]]}</div>);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.MONTHLY) {
            repeatData.push(<div key="date">Repeat date = every {repeat.RepeatDay[0]}'th</div>);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.FREE) {
            var repeatDates = '';
            for (var i = 0; i < repeat.RepeatDates.length; i++) {
                console.log(repeat.RepeatDates[i])
                if (i != 0)
                    repeatDates += ", ";
                repeatDates += repeat.RepeatDates[i];
            }

            repeatData.push(<div key="dates">Repeat dates = {repeatDates}</div>);
        }
    }
    return repeatData;
}

function parseRepeatDataCSV(repeat) {
    var repeatData = [];
    if (repeat != null) {
        repeatData.push("Repeat type = " + repeat.RepeatType);
        if (repeat.RepeatTypeID == enums.PLAN_REPEAT.WEEKLY)// || repeat.repeatTypeID == enums.PLAN_REPEAT.BIWEEKLY)
        {
            repeatData.push("Repeat day = " + weekday[repeat.RepeatDay[0]]);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.BIWEEKLY) {
            repeatData.push("Repeat days = " + weekday[repeat.RepeatDay[0]], weekday[repeat.RepeatDay[1]]);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.MONTHLY) {
            repeatData.push("Repeat date = every " + repeat.RepeatDay[0]);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.FREE) {
            var repeatDates = '';
            for (var i = 0; i < repeat.RepeatDates.length; i++) {
                console.log(repeat.RepeatDates[i])
                if (i != 0)
                    repeatDates += ", ";
                repeatDates += repeat.RepeatDates[i];
            }

            repeatData.push("Repeat dates = " + repeatDates);
        }
    }
    return repeatData.join();
}


function dateFormatter(cell, row) {
    if (cell == null)
        return '';
    return dateHelper.fromStrToStrWithoutTime(cell);
}



// WEBPACK FOOTER //
// ./modules/patientSummary/Plans.jsx